import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _answerChallengeRequest = {};
var _answerChallengeResponse = {};
var _getChallengeRequest = {};
var _getChallengeResponse = {};
var _isVerifiedRequest = {};
var _isVerifiedResponse = {};
var _verificationCheckByIdRequest = {};
var _verificationCheckRequest = {};
var _verificationCheckResponse = {};
var _verificationGenerateCodeRequest = {};
var _verificationGenerateCodeResponse = {};
var _verificationStartRequest = {};
var _verificationStartResponse = {};
function resolveComWixpressVerificationApiVerificationUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/verification-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/verification-web/v1/challenges/get-challenge',
                destPath: '/v1/get-challenge',
            },
            {
                srcPath: '/_api/verification-web/v1/challenges/answer-challenge',
                destPath: '/v1/answer-challenge',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/verification-web/v1/challenges/get-challenge',
                destPath: '/v1/get-challenge',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Sends verification code (VALID only once for 10 min) */
export function start(payload) {
    var _a = serializer(_verificationStartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verificationStartResponse, {}).fromJSON;
    function __start(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'POST',
            methodFqn: 'com.wixpress.verification.api.Verification.start',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/start',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __start.fromReq = fromReq;
    __start.__isAmbassador = true;
    return __start;
}
/** Generates verification code without sending it (VALID only once for 10 min) */
export function generateCode(payload) {
    var _a = serializer(_verificationGenerateCodeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verificationGenerateCodeResponse, {}).fromJSON;
    function __generateCode(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'POST',
            methodFqn: 'com.wixpress.verification.api.Verification.generateCode',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/generateCode',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateCode.fromReq = fromReq;
    __generateCode.__isAmbassador = true;
    return __generateCode;
}
/**
 * Checks if a verification code is correct by user identity
 * @deprecated It has been replaced with checkById(), and will be removed on 2024-08-01.
 */
export function check(payload) {
    var _a = serializer(_verificationCheckRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verificationCheckResponse, {}).fromJSON;
    function __check(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'POST',
            methodFqn: 'com.wixpress.verification.api.Verification.check',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/check',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __check.fromReq = fromReq;
    __check.__isAmbassador = true;
    return __check;
}
/** Checks if a verification code is correct by verification id */
export function checkById(payload) {
    var _a = serializer(_verificationCheckByIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verificationCheckResponse, {}).fromJSON;
    function __checkById(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'POST',
            methodFqn: 'com.wixpress.verification.api.Verification.checkById',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/checkById',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkById.fromReq = fromReq;
    __checkById.__isAmbassador = true;
    return __checkById;
}
/** Checks if a verification process is verified. */
export function isVerified(payload) {
    var _a = serializer(_isVerifiedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isVerifiedResponse, {}).fromJSON;
    function __isVerified(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'GET',
            methodFqn: 'com.wixpress.verification.api.Verification.IsVerified',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/is-verified',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isVerified.fromReq = fromReq;
    __isVerified.__isAmbassador = true;
    return __isVerified;
}
/** Approves or declines a verification challenge */
export function answerChallenge(payload) {
    var _a = serializer(_answerChallengeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_answerChallengeResponse, {}).fromJSON;
    function __answerChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'PUT',
            methodFqn: 'com.wixpress.verification.api.Verification.AnswerChallenge',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/answer-challenge',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __answerChallenge.fromReq = fromReq;
    __answerChallenge.__isAmbassador = true;
    return __answerChallenge;
}
/** Returns a verification challenge */
export function getChallenge(payload) {
    var _a = serializer(_getChallengeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getChallengeResponse, {}).fromJSON;
    function __getChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.v1.verification',
            method: 'GET',
            methodFqn: 'com.wixpress.verification.api.Verification.GetChallenge',
            url: resolveComWixpressVerificationApiVerificationUrl({
                protoPath: '/v1/get-challenge',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getChallenge.fromReq = fromReq;
    __getChallenge.__isAmbassador = true;
    return __getChallenge;
}
//# sourceMappingURL=http.impl.js.map